/* Blocant, nu defer: trebuie sa ruleze inaintea primului paint. CARD duplicat minimal din amphr-skeleton.js — tine-le in sincron. */
(function () {
  'use strict';

  var grid = document.querySelector('[data-favorites-grid]');
  if (!grid) return;

  var KEY = 'amphr:favorites';
  // Shared with amphr-favorites-page.js: attribute name section-amphr-favorites.css keys its .favempty{display:none} rule on.
  var EMPTY_HIDDEN_ATTR = 'data-fav-empty-hidden';
  var CARD =
    '<div class="card card--sk" aria-hidden="true">' +
      '<div class="ph sk">&nbsp;<span class="sk-fav"></span></div>' +
      '<div class="add sk"></div>' +
      '<div class="ct sk sk-line">&nbsp;</div>' +
      '<h4 class="sk sk-line">&nbsp;</h4>' +
      '<div class="pr sk sk-line">&nbsp;</div>' +
      '<div class="sw"><span class="sk sw-dot"></span><span class="sk sw-dot"></span><span class="sk sw-dot"></span></div>' +
    '</div>';

  function readHandles() {
    var raw;
    try {
      raw = window.localStorage.getItem(KEY);
    } catch (e) {
      return [];
    }
    if (!raw) return [];
    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return [];
    }
    if (!data || data.v !== 1 || Object.prototype.toString.call(data.items) !== '[object Array]') return [];
    return data.items.filter(function (h) { return typeof h === 'string' && h.length > 0; });
  }

  var handles = readHandles();
  if (!handles.length) return;

  // grid.parentElement is .favpage: already open in the parse stream even though .favempty (a later sibling) is not yet.
  if (grid.parentElement) grid.parentElement.setAttribute(EMPTY_HIDDEN_ATTR, '');
  grid.setAttribute('aria-busy', 'true');
  handles.forEach(function (h) {
    var wrap = document.createElement('div');
    wrap.innerHTML = CARD;
    var el = wrap.firstElementChild;
    el.setAttribute('data-sk-handle', h);
    grid.appendChild(el);
  });
})();
